import React from 'react'
import { useRouter } from 'next/router'
import { FormattedMessage } from 'react-intl'
import styles from './company.module.scss'

const Company = () => {
  const router = useRouter()
  return (
    <div>
      <header className="border-b300 mb-5">
        <h1 className={`h1 tx-oswald tx-w700 ${styles.h1}`}>
          SOUND ON LIVE, Inc.
        </h1>
        <h2 className="tx-18 tx-w400 mb-5">
          <FormattedMessage
            id="about.lead"
            defaultMessage="Company Information"
          />
        </h2>
        <p className="tx-g900">
          {/* eslint-disable-next-line max-len */}
          We are on a mission to build the world&apos;s best community for music
          to share, grow, and get support. We help artists <i>(like you)</i> share
          music to show off your current projects, boost your activity, and love
          what you do no matter what kind of professional you are.
        </p>
        <p className="tx-g900">
          {/* eslint-disable-next-line max-len */}
          We are perfectionists who take pride in coming up with disruptive and
          immersive digital experiences.
        </p>
        <p className="tx-g900 mb-5">
          We are musicians, designers, developers, music fanatics, party harders,
          freaks and nerds.
        </p>
      </header>
      <section className="mb-5 pb-5">
        <h3 className="mb-4">
          <FormattedMessage
            id="about.company.title"
            defaultMessage="Company Information"
          />
        </h3>
        <div className={`w100p ${styles.table}`}>
          <div className={`border-b300 d-md-flex ${styles.tr}`}>
            <div
              className={`${styles.th} px-md-3 pb-md-3 tx-g700 tx-12 tx-md-16 pb-1 pt-3`}
            >
              <FormattedMessage
                id="about.company.name"
                defaultMessage="Company Name"
              />
            </div>
            <div className="pt-md-3 px-md-3 pb-3 pt-0">
              <FormattedMessage
                id="about.company.soundonlive"
                defaultMessage="SOUND ON LIVE, Inc."
              />
            </div>
          </div>
          <div className={`border-b300 d-md-flex ${styles.tr}`}>
            <div
              className={`${styles.th} px-md-3 pb-md-3 tx-g700 tx-12 tx-md-16 pb-1 pt-3`}
            >
              <FormattedMessage
                id="about.company.founder"
                defaultMessage="Founder"
              />
            </div>
            <div className="pt-md-3 px-md-3 pb-3 pt-0">
              <FormattedMessage
                id="about.company.miyanishi"
                defaultMessage="Hiro Miyanishi"
              />
            </div>
          </div>
          <div className={`border-b300 d-md-flex ${styles.tr}`}>
            <div
              className={`${styles.th} px-md-3 pb-md-3 tx-g700 tx-12 tx-md-16 pb-1 pt-3`}
            >
              <FormattedMessage
                id="about.company.founded"
                defaultMessage="Founded At"
              />
            </div>
            <div className="pt-md-3 px-md-3 pb-3 pt-0">
              <FormattedMessage
                id="about.company.foundeddate"
                defaultMessage="April, 2015"
              />
            </div>
          </div>
        </div>
      </section>
      {router.locale !== 'en' && (
        <section className="mb-5 pb-5">
          <h3 className="mb-5">特定商取引法に基づく表記</h3>
          <h4 className="tx-20 tx-g800 mb-3">お支払いについて</h4>
          <p className="tx-g600 tx-14 mb-5">
            販売価格は税込での表記となっており、商品毎に掲載しております。
            <br />
            楽曲の購入に関しては、クレジットカード決済でのお支払いになります。
            <br />
            購入した楽曲に関しては、クレジットカードでの購入手続き終了後すぐにダウンロードすることができます。
          </p>
          <h4 className="tx-20 tx-g800 mb-3">返金・返品について</h4>
          <p className="tx-g600 tx-14 mb-5">
            ダウンロード商品の性質上、返品は承っておりません
          </p>
          <h4 className="tx-20 tx-g800 mb-5">運営者情報</h4>
          <div className={`w100p ${styles.table}`}>
            <div className={`border-b300 d-md-flex ${styles.tr}`}>
              <div
                className={`${styles.th} tx-g700 tx-12 tx-md-16 px-md-3 pb-md-3 pb-1 pt-3`}
              >
                運営事業者名
              </div>
              <div className="pt-md-3 px-md-3 pb-3 pt-0">
                サウンドオンライブ株式会社
              </div>
            </div>
            <div className={`border-b300 d-md-flex ${styles.tr}`}>
              <div
                className={`${styles.th} tx-g700 tx-12 tx-md-16 px-md-3 pb-md-3 pb-1 pt-3`}
              >
                代表者
              </div>
              <div className="pt-md-3 px-md-3 pb-3 pt-0">宮西 洋充</div>
            </div>
            <div className={`border-b300 d-md-flex ${styles.tr}`}>
              <div
                className={`${styles.th} tx-g700 tx-12 tx-md-16 px-md-3 pb-md-3 pb-1 pt-3`}
              >
                所在地
              </div>
              <div className="pt-md-3 px-md-3 pb-3 pt-0">
                〒155-0031 東京都世田谷区北沢2-33-5
                <br />
                下北沢TKSビル 2FA
              </div>
            </div>
            <div className={`border-b300 d-md-flex ${styles.tr}`}>
              <div
                className={`${styles.th} tx-g700 tx-12 tx-md-16 px-md-3 pb-md-3 pb-1 pt-3`}
              >
                問い合わせ先
              </div>
              <div className="pt-md-3 px-md-3 pb-3 pt-0">
                hello [at] soundonlive.com
              </div>
            </div>
            <div className={`border-b300 d-md-flex ${styles.tr}`}>
              <div
                className={`${styles.th} tx-g700 tx-12 tx-md-16 px-md-3 pb-md-3 pb-1 pt-3`}
              >
                電話番号
              </div>
              <div className="pt-md-3 px-md-3 pb-3 pt-0">
                <span className="tx-gray">0422-57-6516</span>
                <br />
                <span className="tx-12">
                  電話でのお問い合わせは受け付けておりません。
                  <br />
                  サポートはメールのみとなります。あらかじめご了承いただきますようお願いいたします。
                </span>
              </div>
            </div>
          </div>
        </section>
      )}
    </div>
  )
}

export default Company
